/**
 * Communes officielles des Antilles et de la Guyane (source : geo.api.gouv.fr, code officiel géographique de l'INSEE,
 * octobre 2026), avec leurs codes postaux (La Poste). Sert à choisir la commune au lieu de l'écrire : pas de faute
 * d'orthographe, tri et filtres fiables par commune et par code postal.
 */
export const DEPARTMENT_LABEL: Record<string, string> = {
  '971': 'Guadeloupe',
  '972': 'Martinique',
  '973': 'Guyane',
  '977': 'Saint-Barthélemy',
  '978': 'Saint-Martin',
};

export interface Commune {
  dept: string;
  insee: string;
  name: string;
  postalCodes: string[];
}

const RAW: [string, string, string, string[]][] = [
  ['971', '97101', "Les Abymes", ['97139', '97142']],
  ['971', '97102', "Anse-Bertrand", ['97121']],
  ['971', '97103', "Baie-Mahault", ['97122']],
  ['971', '97104', "Baillif", ['97123']],
  ['971', '97105', "Basse-Terre", ['97100']],
  ['971', '97106', "Bouillante", ['97125']],
  ['971', '97107', "Capesterre-Belle-Eau", ['97130']],
  ['971', '97108', "Capesterre-de-Marie-Galante", ['97140']],
  ['971', '97109', "Gourbeyre", ['97113']],
  ['971', '97110', "La Désirade", ['97127']],
  ['971', '97111', "Deshaies", ['97126']],
  ['971', '97112', "Grand-Bourg", ['97112']],
  ['971', '97113', "Le Gosier", ['97190']],
  ['971', '97114', "Goyave", ['97128']],
  ['971', '97115', "Lamentin", ['97129']],
  ['971', '97116', "Morne-à-l'Eau", ['97111']],
  ['971', '97117', "Le Moule", ['97160']],
  ['971', '97118', "Petit-Bourg", ['97170']],
  ['971', '97119', "Petit-Canal", ['97131']],
  ['971', '97120', "Pointe-à-Pitre", ['97110']],
  ['971', '97121', "Pointe-Noire", ['97116']],
  ['971', '97122', "Port-Louis", ['97117']],
  ['971', '97124', "Saint-Claude", ['97120']],
  ['971', '97125', "Saint-François", ['97118']],
  ['971', '97126', "Saint-Louis", ['97134']],
  ['971', '97128', "Sainte-Anne", ['97180']],
  ['971', '97129', "Sainte-Rose", ['97115']],
  ['971', '97130', "Terre-de-Bas", ['97136']],
  ['971', '97131', "Terre-de-Haut", ['97137']],
  ['971', '97132', "Trois-Rivières", ['97114']],
  ['971', '97133', "Vieux-Fort", ['97141']],
  ['971', '97134', "Vieux-Habitants", ['97119']],
  ['972', '97201', "L'Ajoupa-Bouillon", ['97216']],
  ['972', '97202', "Les Anses-d'Arlet", ['97217']],
  ['972', '97203', "Basse-Pointe", ['97218']],
  ['972', '97204', "Le Carbet", ['97221']],
  ['972', '97205', "Case-Pilote", ['97222']],
  ['972', '97206', "Le Diamant", ['97223']],
  ['972', '97207', "Ducos", ['97224']],
  ['972', '97208', "Fonds-Saint-Denis", ['97250']],
  ['972', '97209', "Fort-de-France", ['97200', '97234']],
  ['972', '97210', "Le François", ['97240']],
  ['972', '97211', "Grand'Rivière", ['97218']],
  ['972', '97212', "Gros-Morne", ['97213']],
  ['972', '97213', "Le Lamentin", ['97232']],
  ['972', '97214', "Le Lorrain", ['97214']],
  ['972', '97215', "Macouba", ['97218']],
  ['972', '97216', "Le Marigot", ['97225']],
  ['972', '97217', "Le Marin", ['97290']],
  ['972', '97218', "Le Morne-Rouge", ['97260']],
  ['972', '97219', "Le Prêcheur", ['97250']],
  ['972', '97220', "Rivière-Pilote", ['97211']],
  ['972', '97221', "Rivière-Salée", ['97215']],
  ['972', '97222', "Le Robert", ['97231']],
  ['972', '97223', "Saint-Esprit", ['97270']],
  ['972', '97224', "Saint-Joseph", ['97212']],
  ['972', '97225', "Saint-Pierre", ['97250']],
  ['972', '97226', "Sainte-Anne", ['97227']],
  ['972', '97227', "Sainte-Luce", ['97228']],
  ['972', '97228', "Sainte-Marie", ['97230']],
  ['972', '97229', "Schœlcher", ['97233']],
  ['972', '97230', "La Trinité", ['97220']],
  ['972', '97231', "Les Trois-Îlets", ['97229']],
  ['972', '97232', "Le Vauclin", ['97280']],
  ['972', '97233', "Le Morne-Vert", ['97226']],
  ['972', '97234', "Bellefontaine", ['97222']],
  ['973', '97301', "Régina", ['97353', '97390']],
  ['973', '97302', "Cayenne", ['97300']],
  ['973', '97303', "Iracoubo", ['97350']],
  ['973', '97304', "Kourou", ['97310']],
  ['973', '97305', "Macouria", ['97355']],
  ['973', '97306', "Mana", ['97318', '97360']],
  ['973', '97307', "Matoury", ['97351']],
  ['973', '97308', "Saint-Georges", ['97313']],
  ['973', '97309', "Remire-Montjoly", ['97354']],
  ['973', '97310', "Roura", ['97311', '97352']],
  ['973', '97311', "Saint-Laurent-du-Maroni", ['97320']],
  ['973', '97312', "Sinnamary", ['97315']],
  ['973', '97313', "Montsinéry-Tonnegrande", ['97356']],
  ['973', '97314', "Ouanary", ['97380']],
  ['973', '97352', "Saül", ['97314']],
  ['973', '97353', "Maripasoula", ['97370']],
  ['973', '97356', "Camopi", ['97330']],
  ['973', '97357', "Grand-Santi", ['97340']],
  ['973', '97358', "Saint-Élie", ['97312']],
  ['973', '97360', "Apatou", ['97317']],
  ['973', '97361', "Awala-Yalimapo", ['97319']],
  ['973', '97362', "Papaichton", ['97316']],
  ['977', '97701', "Saint-Barthélemy", ['97133']],
  ['978', '97801', "Saint-Martin", ['97150']],
];

export const COMMUNES: readonly Commune[] = RAW.map(([dept, insee, name, postalCodes]) => ({ dept, insee, name, postalCodes }));

/** codes postaux couverts par la liste (971 à 973, Saint-Barthélemy, Saint-Martin) */
export const isListedPostalArea = (postalCode: string | null | undefined) => /^97[123]\d\d$|^97133$|^97150$/.test((postalCode ?? '').replace(/\s/g, ''));

/** « St-François », « saint francois », « ST FRANCOIS » → même clé ; « Le Gosier » = « Gosier » */
export function communeKey(name: string): string {
  return name
    .toLowerCase()
    .replace(/œ/g, 'oe')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\bste\b/g, 'sainte')
    .replace(/\bst\b/g, 'saint')
    .replace(/^(les|le|la|l) /, '')
    .replace(/\s+/g, ' ');
}

export function communesForPostalCode(postalCode: string | null | undefined): Commune[] {
  const cp = (postalCode ?? '').replace(/\s/g, '');
  return cp.length === 5 ? COMMUNES.filter((c) => c.postalCodes.includes(cp)) : [];
}

/** recherche par nom (début de mot, sans accents) : pour la liste de suggestions */
export function searchCommunes(query: string, limit = 12): Commune[] {
  const q = communeKey(query);
  if (!q) return [];
  const starts = COMMUNES.filter((c) => communeKey(c.name).startsWith(q) || communeKey(c.name).split(' ').some((w) => w.startsWith(q)));
  return starts.slice(0, limit);
}

/** abréviations courantes */
const ALIASES: Record<string, string> = { pap: 'pointe a pitre', fdf: 'fort de france', slm: 'saint laurent du maroni' };

/** la commune officielle correspondant à un nom (et au code postal s'il est donné) */
export function findCommune(name: string | null | undefined, postalCode?: string | null): Commune | null {
  if (!name?.trim()) return null;
  const raw = communeKey(name);
  const key = ALIASES[raw] ?? raw;
  const cp = (postalCode ?? '').replace(/\s/g, '');
  const hits = COMMUNES.filter((c) => communeKey(c.name) === key && (!cp || c.postalCodes.includes(cp)));
  return hits.length === 1 ? hits[0]! : null;
}

/** « 97122 Baie-Mahault » : libellé d'une option (commune + code postal) */
export const communeOption = (c: Commune, postalCode = c.postalCodes[0]!) => `${postalCode} ${c.name}`;

/**
 * Adresse aux Antilles / en Guyane : la commune doit exister et correspondre au code postal ; l'orthographe est
 * ramenée à celle officielle. Ailleurs (métropole…) : saisie libre, inchangée.
 */
export function normalizeCommune(postalCode: string | null | undefined, city: string | null | undefined): {
  postalCode: string | null;
  city: string | null;
  error?: { path: 'postalCode' | 'city'; message: string };
} {
  const cp = (postalCode ?? '').replace(/\s/g, '') || null;
  const name = city?.trim() || null;
  if (cp && isListedPostalArea(cp)) {
    const options = communesForPostalCode(cp);
    if (!options.length) return { postalCode: cp, city: name, error: { path: 'postalCode', message: 'Code postal inconnu' } };
    if (!name) return { postalCode: cp, city: options.length === 1 ? options[0]!.name : null };
    const hit = findCommune(name, cp);
    if (hit) return { postalCode: cp, city: hit.name };
    return {
      postalCode: cp,
      city: name,
      error: { path: 'city', message: `Commune à choisir dans la liste : ${options.map((c) => c.name).join(', ')}` },
    };
  }
  if (!cp && name) {
    // commune des Antilles / Guyane saisie sans code postal : complété s'il n'y en a qu'un
    const hit = findCommune(name);
    if (hit) return { postalCode: hit.postalCodes.length === 1 ? hit.postalCodes[0]! : null, city: hit.name };
  }
  return { postalCode: cp, city: name };
}

/**
 * Applique normalizeCommune aux champs d'un objet (client : postalCode / city ; chantier : sitePostalCode / siteCity).
 * Renvoie l'objet corrigé (orthographe officielle, code postal ou commune complétés) et les erreurs par champ.
 */
export function withOfficialCommune<T extends object>(
  o: T,
  cpKey: keyof T & string,
  cityKey: keyof T & string,
  /** modification : seul le champ changé fait foi, l'autre suit (nouvelle commune → son code postal, et inversement) */
  changed?: 'postalCode' | 'city',
): { value: T; errors: Record<string, string> } {
  let cp = o[cpKey] as string | null | undefined;
  let city = o[cityKey] as string | null | undefined;
  if (changed === 'city') {
    const hit = findCommune(city);
    if (hit && !hit.postalCodes.includes((cp ?? '').replace(/\s/g, ''))) cp = hit.postalCodes.length === 1 ? hit.postalCodes[0]! : null;
  } else if (changed === 'postalCode') {
    const options = communesForPostalCode(cp);
    if (options.length && !findCommune(city, cp)) city = options.length === 1 ? options[0]!.name : null;
  }
  const r = normalizeCommune(cp, city);
  const value = { ...o, [cpKey]: r.postalCode, [cityKey]: r.city } as T;
  return { value, errors: r.error ? { [r.error.path === 'postalCode' ? cpKey : cityKey]: r.error.message } : {} };
}

/** lequel des deux champs une modification touche seule (les deux, ou aucun : undefined) */
export function changedField<C extends string, Y extends string>(patch: object, cpKey: C, cityKey: Y): 'postalCode' | 'city' | undefined {
  const cp = cpKey in patch;
  const city = cityKey in patch;
  return cp && !city ? 'postalCode' : city && !cp ? 'city' : undefined;
}
